// @flow
import type {BootstrapColorNameType, ColorType, ThemeType} from 'trustar-2.0/types';
import {DefaultTheme} from 'trustar-2.0/themes';
import {DEFAULT_THEME, DARK_THEME} from './constants';

export const getButtonColorDefaultTheme = (bootstrapName: BootstrapColorNameType): ColorType => {
  return getButtonColorWithTheme(bootstrapName, DefaultTheme);
};

export const getButtonColorWithTheme = (bootstrapName: BootstrapColorNameType, theme: ThemeType): ColorType => {
  const ThemeColors = theme.ThemeColors;

  switch (bootstrapName) {
  case 'primary':
    return ThemeColors.PRIMARY;
  case 'secondary':
    return ThemeColors.SECONDARY;
  case 'tertiary':
    return ThemeColors.TERTIARY;
  case 'warning':
    return ThemeColors.WARNING;
  case 'danger':
    return ThemeColors.DANGER;
  case 'light':
    return ThemeColors.LIGHT;
  case 'dark':
    return ThemeColors.DARK;
  case 'success':
    return ThemeColors.SUCCESS;
  case 'info':
    return ThemeColors.INFO;
  default:
    return ThemeColors.PRIMARY;
  }
};


// If we want some color to have different shades for their hover, default is X600
const hoverShadeMap = {
  // 'MINE_SHAFT' : 'X600'   // Example
};

export function getHoverShade() {
  const customShade = hoverShadeMap[this.name];
  return customShade ? this[customShade] : this.X600;
}

export function makeBaseHex(color: any, xValue: string = 'X700') {
  return Object.assign({}, color, {hex: color[xValue]});
}

export function inDarkMode(theme: ThemeType) {
  return theme.Config.name === 'Dark Theme';
}


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/common/util.js